import { BaseModel } from './BaseModel';

export default class Menu extends BaseModel {
  // Default attributes that define the "empty" state.
  defaults() {
    return {
      id: '',
      name: '',
      facility_id: 0,
      facility: {},
      tax_rate: 0,
      menuCategories: [],
      brandIds: [],
      brands: [],
      connector_source_id: 0,
      status: 'active',
      unavailable_message: '',
      brandMenuItemCount: {},
    };
  }

  options() {
    return {
      identifier: 'id',
    };
  }

  // Route configuration
  routes() {
    return {
      fetch: '/menus/{id}?with=brands,facility&appends=brandMenuItemCount',
      save: '/menus/{id}',
    };
  }

  // Override onFetchSuccess
  onFetchSuccess(response) {
    const me = this;
    const data = response.getData();
    if (!data || !data.success) {
      throw me.createResponseError('Invalid menu');
    }

    me.assign(data.data);
    me.set(me, 'fatal', false);
    me.set(me, 'loading', false);
    me.emit('fetch', {
      error: null,
    });
  }
}
